import { useEffect } from "react";
import { Message } from "../types";

export const postResizeMessage = (minHeight = 0) => {
  requestAnimationFrame(() => {
    const height = Math.max(document.body.scrollHeight, Math.ceil(minHeight));
    const message: Message = { height, type: "resize" };
    window.parent.postMessage(message, "*");
  });
};

const useResizeMessage = () => {
  useEffect(() => {
    const handleResize = () => postResizeMessage();

    const observer = new ResizeObserver(handleResize);
    observer.observe(document.body);

    handleResize();

    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useResizeMessage;
